export const useSnakeCase = (str) => {
  return str
    .replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`)
    .replace(/\s+/g, "_")
    .replace(/-+/g, "_")
    .replace(/_+/g, "_")
    .replace(/^_+|_+$/g, "")
    .toLowerCase();
};

export const useKebabCase = (str) => {
  return str
    .replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`)
    .replace(/\s+/g, "-")
    .replace(/_+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-+|-+$/g, "")
    .toLowerCase();
};
export const useCamelCase = (str) => {
  return str
    .replace(/[-_]+(.)?/g, (_, c) => (c ? c.toUpperCase() : ""))
    .replace(/^[A-Z]/, (c) => c.toLowerCase());
};
export const usePascalCase = (str) => {
  return str
    .replace(/[-_]+(.)?/g, (_, c) => (c ? c.toUpperCase() : ""))
    .replace(/^\w/, (c) => c.toUpperCase());
};
export const useCapitalizeWords = (str) => {
  return str.replace(/\b\w/g, (c) => c.toUpperCase());
};

export const camelCaseToPhrase = (camelCaseStr) => {
  const result = camelCaseStr.replace(/([a-z])([A-Z])/g, "$1 $2").toLowerCase();
  // first char after spacing will be upper case
  return result.replace(/\b\w/g, (char) => char.toUpperCase());
};
